import React, { Component } from "react"
import Svg from "../../../_svgs/svg"

export default class MerchantQuickAccessImageLinks extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div className="four-link-box">
        <header className="article__header">
          <h1 data-epi-edit="Heading">{this.props.heading}</h1>
          <span className="main-text" data-epi-edit="Text">
            {this.props.text}
          </span>
        </header>
        <div className="four-link-box__content">
          <ul>
            {this.props.imageLinkBlocks
              ? this.props.imageLinkBlocks.map((block, index) => {
                  return (
                    <li key={index}>
                      <a href={block.link} data-epi-edit="LinkText">
                        <img src={block.image} alt="" data-epi-edit="Image" />
                        {block.linkText ? (
                          <React.Fragment>
                            <Svg iconName={"arrowright"} fillColor={"#808080"} />
                            {block.linkText}
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                      </a>
                    </li>
                  )
                })
              : ""}
          </ul>
        </div>
      </div>
    )
  }
}
